<div class="modal modal-full fade commentModal" id="offcanvas-inspect" [collapse]="isCollapsed" tabindex="-1">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="offcanvas-header">
                <button type="button" class="btn-close" (click)="closeInspection()">
                    <img src="assets/icons/closeOutlined.svg" />
                </button>
            </div>

            <div class="offcanvas-body ui-dialog-fixed">
                <div *ngIf="additionalInfo" [ngxSummernoteView]="additionalInfo"></div>

                <div *ngIf="additionalInfoData.informationSection && additionalInfoData.informationSection.length > 0">
                    <h2 style="font-family: Panton; font-size: 22px !important; font-weight: bold; line-height: 29px;">{{ 'CHECK.INFO_SECTION' | translate }}</h2>
                    <div [ngxSummernoteView]="additionalInfoData.informationSection"></div>
                </div>

                <div *ngIf="additionalInfoData.formalBasics && additionalInfoData.formalBasics.length > 0">
                    <h2 style="font-family: Panton; font-size: 22px !important; font-weight: bold; line-height: 29px;">{{ 'CHECK.FORMAL_BASICS' | translate }}</h2>
                    <div [ngxSummernoteView]="additionalInfoData.formalBasics"></div>
                </div>
            </div>

            <div class="offcanvas-footer">
                <button type="button" class="btn btn-cancel" (click)="closeInspection()">{{ 'INSTITUTION_MANAGEMENT.CLOSE' | translate }}</button>
            </div>
        </div>
    </div>
</div>